export default "__VITE_ASSET__DlDbZpHh__"